import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Container,
    List, ListItem, ListItemButton, ListItemText, ListSubheader
} from "@mui/material";
import { listaDeInformes } from "@/Routes/listaDeInformes";
import { slideInUp } from 'react-animations';
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@/redux/store";
import { ObtenerInformesPorSubdivision, isEmptyObject } from "@/utils/allUtils";

const RenderCard = ({ tipo, name, headerColor }: { tipo: seccionType, name: string, headerColor: any }) => {
    const navigate = useNavigate();
    const isDark = useAppSelector((state: { theme: { darkTheme: any; }; }) => state.theme.darkTheme)
    const InformesPorTipo = listaDeInformes.filter((informe) => informe.seccion === tipo);
    const informesPorSubdivision = ObtenerInformesPorSubdivision(InformesPorTipo)
    
    const ItemComponent = ({ name, path }: { name: string, path: string }) => {
        let newName: string = name.toLocaleLowerCase().replace(tipo.toLocaleLowerCase(), '').trim();
        newName = newName.charAt(0).toUpperCase() + newName.slice(1);
        newName = newName.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
        newName = newName.replaceAll(' De ', ' de ');
        newName = newName.replaceAll(' En ', ' en ');
        newName = newName.replaceAll('íN', ' Ín');
        newName = newName.replaceAll(' Al', ' al');
        newName = newName.replaceAll(' Y ', ' y ');


        return <ListItem disablePadding>
            <ListItemButton onClick={() => navigate(`/informe/${path}`)}>


                <ListItemText primary={newName}
                    primaryTypographyProps={{
                        textAlign: 'center',
                        fontFamily: 'unset',
                        fontSize: '2ch',
                        fontWeight: 400,
                    }}

                />
            </ListItemButton>
        </ListItem>
    }

    const ItemsPorSubdivision = () => {
        return (
            <Box sx={{ width: '100%' }}>
                {Object.entries(informesPorSubdivision).map(([subdivision, informes]) => {
                    return (
                        <List
                            key={`k-menu-${subdivision}`}
                            subheader={
                                <ListSubheader
                                    sx={{
                                        backgroundColor: isDark ? '#ffffff03' : headerColor,
                                        '& ul': { padding: 0 },
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {subdivision.toString().toUpperCase()}
                                </ListSubheader>
                            }
                        >
                            {informes.map((informe: any) => <ItemComponent key={`k-menu-${informe.path}`} name={informe.nombre} path={informe.path} />)}
                        </List>
                    )
                })}


            </Box>
        )
    }
    const ItemsSinDivision = () => {
        return (
            <List>
                {InformesPorTipo.map((informe) => <ItemComponent key={`k-menu-${informe.path}`} name={informe.nombre} path={informe.path} />)}
            </List>
        )
    }


    return <Card sx={{
        height: '100%',
        maxWidth: '23rem',
        width: '100%',
        boxShadow: `0px 0px 6px #000`,
        zIndex: 1,
        '@keyframes a': slideInUp,
        animation: 'a 0.2s',
    }}>
        <CardHeader
            sx={{
                backgroundColor: isDark ? '#ffffff03' : headerColor,
                '& ul': { padding: 0 },
            }}
            title={name}
            titleTypographyProps={{
                variant: 'h4', textAlign: 'center', pb: 0,
                fontWeight: '400',
            }}
        >
        </CardHeader>
        <CardContent
            sx={{ pt: 0, p: 0 }}
        >

            {
                !isEmptyObject(informesPorSubdivision) ?
                    ItemsPorSubdivision()
                    : ItemsSinDivision()
            }
        </CardContent>

    </Card >
}


const SectionCards = () => {



    return (

        <div aria-label="cards">
            <Container maxWidth='xl'>
                <Box aria-label="cards-container"
                    display="grid"
                    sx={{
                        gridTemplateColumns: 'repeat(auto-fit, minmax(18rem, 1fr))',
                        justifyContent: 'center',
                        alignItems: 'start',
                        justifyItems: 'center',
                        padding: '1rem',
                        gridGap: '1rem',
                        zIndex: 1,
                    }}
                >
                    <RenderCard tipo="capital" name="Capital" headerColor={'#ebebeb'} />
                    <RenderCard tipo="provincia" name="Provincia" headerColor={'#ebebeb'} />
                    <RenderCard tipo="catastro" name="Catastro" headerColor={'#ebebeb'} />
                    <RenderCard tipo="otros" name="Otros Informes" headerColor={'#ebebeb'} />
                </Box>
            </Container>

        </div>



    );
}



export default SectionCards;